/**
 * frontend profile API access
 */

import { Profile } from "~/models/profile";
import { wpFetch } from "./wpfetch";
import { API_PEOPLE_CATEGORIES_URL } from "./base";

export const getProfilesInCategory = async (
  taxonomy: string,
  slug: string,
): Promise<Profile[]> => {
  const response = await wpFetch(
    `${API_PEOPLE_CATEGORIES_URL}/${taxonomy}/${slug}`,
    {
      method: "GET",
    },
  );
  return response as Profile[];
};
